import { configureStore } from '@reduxjs/toolkit';

import activeChatItem from './activeChatItemSlice';
import chatHistory from './chatHistorySlice';
import chemicalStoreSlice from './chemicalStoreSlice';
import productSelector from './productSelectorSlice';
import userData from './userDataSlice';

const ChatbotStore = configureStore({
  reducer: { userData, chatHistory, activeChatItem, productSelector, chemicalStoreSlice },
});

export type ChatbotState = ReturnType<typeof ChatbotStore.getState>;
export default ChatbotStore;
